import { Pagination } from 'core/pagination/Pagination';
export type Agency = {
  readonly id: number;
  readonly name: string;
  readonly vendorNumber: string;
  readonly currency: string;
  readonly timeZone: string;
  readonly addOnFeatures: any;
  readonly loginTitle: string | null;
  readonly loginDomain: string | null;
  readonly detail: AgencyDetail;
};

export type AgencyWithPagination = {
  pagination: Pagination;
  agencies: Agency[];
};

export type AgencyDetail = {
  readonly addonFeatures: any;
  id?: number;
  addonProps: AddonProps;
  companyName: string;
  vendorNumber: string;
  language: Language;
  currency: Currency;
  timeZone: TimeZone;
  comComment: string;
  targetBudgetMinimum?: number;
  campaignBudgetMinimum?: number;
  priority: number;
  limitPublisher: Array<number>;
  agencyId?: number;
  noLimitSelfBuyStatus: boolean;
  selfBuy: boolean;
};

export type AddonProps = {
  fixedExchangeRate: number | null;
  orderBudgetMaximum: number;
  campaignBidPrice?: {
    type: string;
    autoBidCap: { [key: string]: string };
    bidFloor: { [key: string]: string };
  }[];
};

export enum Currency {
  NTD = 'NTD',
}

export enum Language {
  ZHTW = 'zh_TW',
}

export enum TimeZone {
  TAIPEI = '+08:00',
}
